import {Partenaire} from '../../../shared/models/partenaire.model';
import {PartenaireService} from '../../../shared/services/partenaire.service';
import {Component, OnInit} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from '@angular/forms';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {ToastyService} from 'ng2-toasty';

@Component({
  selector: 'app-partenaires-details',
  templateUrl: './partenaires-details.component.html',
  styleUrls: ['./partenaires-details.component.css']
})
export class PartenairesDetailsComponent implements OnInit {

  partner: Partenaire = new Partenaire();
  partnerDetailsForm: FormGroup;

  constructor(private router: Router, private route: ActivatedRoute, private formBuilder: FormBuilder,
    private toastyService: ToastyService, private service: PartenaireService) {
    this.partner = this.route.snapshot.data['partner'];
    this.partnerDetailsForm = this.formBuilder.group({
      'email': ['', Validators.required],
      'name': ['', Validators.required],
      'description': ['']
    });

  }

  ngOnInit() {
    this.partnerDetailsForm.patchValue(this.partner);
  }

  onPartnerDetailsEditCancel(): void {
    this.router.navigate(['/partenaires/list']);
  }

  onPartnerDetailsEditSubmit(): void {
    (<any>Object).assign(this.partner, this.partnerDetailsForm.value);
    console.log(JSON.stringify(this.partner));
    this.service.edit(this.partner)
      .subscribe(data => {this.router.navigate(['/partenaires/list'])});
  }

}
